import React, { useState } from "react";
import "./Weather.css";
import axios from "axios";
import WeatherInfo from "./WeatherInfo.js";
import WeatherForecast from "./WeatherForecast.js";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      name: response.data.city,
      temperature: response.data.temperature.current,
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      description: response.data.condition.description,
      date: new Date(response.data.time * 1000),
      icon: response.data.condition.icon_url,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "b4ffb413431b5d4406b3ot5c80af963a";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}`;
    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <div className="Box Centered">
          <form className="SearchForm" onSubmit={handleSubmit}>
            <input
              className="InputForm"
              type="search"
              placeholder="Perth"
              onChange={handleCityChange}
            />
            <input type="submit" className="SearchButton" />
          </form>
        </div>
        <WeatherInfo data={weatherData} />
        <WeatherForecast name={weatherData.name} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
